import { SessionStorageManager } from '@atlas/core';
import { clientProfileRoutes, paymentRoutes } from '@atlas/routing';

import { POSTHOG_DEPOSIT_SOURCE, POSTHOG_SESSION_KEYS } from 'common/constants';

const DEPOSIT_SOURCES = Object.values(POSTHOG_DEPOSIT_SOURCE);

const getDepositPathSegment = () =>
  `/${clientProfileRoutes?.payment ?? 'payment'}/${paymentRoutes?.deposit ?? 'deposit'}`;

export const isDepositPath = path =>
  typeof path === 'string' && path.split(/[?#]/)[0].includes(getDepositPathSegment());

export const setDepositSource = source => {
  if (!DEPOSIT_SOURCES.includes(source)) return;

  SessionStorageManager.setItem(POSTHOG_SESSION_KEYS.DEPOSIT_SOURCE, source);
};

export const setDepositSourceForPath = (source, path) => {
  if (!isDepositPath(path)) return;

  setDepositSource(source);
};

export const getDepositSource = () => {
  const storedSource = SessionStorageManager.getItem(POSTHOG_SESSION_KEYS.DEPOSIT_SOURCE);

  return DEPOSIT_SOURCES.includes(storedSource) ? storedSource : POSTHOG_DEPOSIT_SOURCE.OTHER;
};

export const removeDepositSource = () => {
  SessionStorageManager.removeItem(POSTHOG_SESSION_KEYS.DEPOSIT_SOURCE);
};
